'use client'

/* eslint-disable @typescript-eslint/no-explicit-any */
/** @format */
import { useAxios } from "@/hooks";
import { endPoint } from "@/utils";
import { usePathname } from "next/navigation";
import toast from "react-hot-toast";
import * as yup from "yup";


const useConsultForm = () => {
	const path = usePathname();
	const initialValues = { name: '', email: '', phone: '', message: '' };
	const validationSchema = yup.object().shape({
		name: yup.string().required('Name is required'),
		email: yup.string().email('Invalid email').required('Email is required'),
		phone: yup
			.string()
			.required('Phone number is required')
			.matches(/^[0-9]+$/, 'Phone number is not valid')
			.min(10, 'Phone number is not valid')
			.max(10, 'Phone number is not valid'),
		message: yup.string().required('Message is required'),
	});
	const { fetchData, loading, error } = useAxios();

	const handleSubmit = async (
		values: any,
		{ setSubmitting, setErrors }: any
	) => {
		const res = await fetchData({
			url: endPoint.POST_CONTACT_FORM,
			method: "POST",
			data: {
				name: values.name,
				mobile: values.phone,
				email: values.email,
				message: values.message,
				from: 'FYDO_WEBSITE',
				pageUrl: path.replace("/", ""),
			},
		});

		if (!res.error) {
			toast.success("Your Consultation has been booked!");
		} else {
			toast.error(res?.message || "Something went wrong!");
			setErrors({ phone: res?.message });
			setSubmitting(false);
		}
	};
	return {
		initialValues,
		validationSchema,
		loading,
		error,
		handleSubmit,
	};
};

export default useConsultForm;
